<template>
  <div class="hosts">
    <h2 class="ui header" v-if="header">
      <i class="server grey icon" />
      <sui-header-content>{{header}}</sui-header-content>
    </h2>
    <transition-group class="ui cards entities" name="card" v-show="hostsList.length || newHost">
      <sui-card class="card-item" key="new" v-show="newHost">
        <div class="ui huge vertical basic fluid buttons content">
          <div class="ui left labeled icon button" :class="{disabled: !access.hostCreate}" data-goal="HOST_CARDS_CREATE" @click.stop.prevent="$modals.createHost.open()">
            <i class="blue cloud icon" />
            Create cloud host
          </div>
          <div class="ui left labeled icon button" :class="{disabled: !access.hostCreate}" data-goal="HOST_CARDS_CONNECT" @click.stop.prevent="$modals.createHost.open({}, 1)">
            <i class="purple server icon" />
            Connect own host
          </div>
        </div>
      </sui-card>
      <HostCard class="card-item" :host="host" :service="service" :container="container" :ports="portsByHost[host.id]" v-for="host in hostsList" :key="host.id" @select="selectRole" />
    </transition-group>
    <sui-segment class="empty" padded v-show="!hostsList.length && !newHost">
      No hosts.
    </sui-segment>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import HostCard from './Host'
  import api from '@/api'

  export default {
    name: 'HostCards',
    components: {
      HostCard,
    },
    props: {
      header: {
        type: String,
        required: false,
        default: 'Hosts',
      },
      list: {
        type: Array,
        required: false,
      },
      newHost: {
        type: Boolean,
        required: false,
        default: true,
      },
      container: {
        type: Object,
        required: false,
      },
      service: {
        type: Object,
        required: false,
        default() {
          return this.container ? this.container._service : null
        }
      },
    },
    data() {
      return {
        portsByHost: [],
      }
    },
    computed: {
      ...mapGetters(['access', 'hosts']),
      hostsList() {
        return this.list || this.hosts
      },
    },
    methods: {
      selectRole(host, newRole) {
        if (!this.service) {
          return false
        }
        let selectedValues = [...(this.container ? this.container.hosts : this.service.hosts)]
        const currentValues = this.service._hostRoles || []
        const allValues = currentValues.concat(selectedValues)
        const [role1, role2] = this.service.constructor.fields.hosts.selector[this.service.configuration || 'default']
        const multiselect = Boolean(role2)
        const multiroles = (role1 && role2) && (role1 !== role2)
        const currentValue = currentValues.find(value => value.id === host.id) || {}
        const selectedIndex = selectedValues.findIndex(value => value.id === host.id)
        const selectedValue = selectedValues[selectedIndex] || {}
        const selectedRole = selectedValue.role || null
        // ignore if it's current
        if (currentValue.role) {
          return false
        }
        // define role if it's undefined
        if (!newRole) {
          newRole = this.container ? this.container.role : (multiroles && allValues.find(value => value.role === role1) ? role2 : role1)
        }
        // remove role if second click
        if (newRole === selectedRole) {
          selectedValues.splice(selectedIndex, 1)
        } else {
          const newValue = {id: host.id, role: newRole}
          if (this.container) {
            selectedValues = [newValue]
          } else if (multiselect) {
            if (multiroles) {
              const hasCurrentRole1 = currentValues.find(value => value.role === role1)
              // replace previous role1 to role2
              for (let index in selectedValues) {
                if (newRole === role1 && selectedValues[index].role === role1) {
                  selectedValues[index].role = role2
                }
              }
              // do nothing if there is current role1 already
              if (newRole === role1 && hasCurrentRole1) {
                return false
              } else {
                selectedValues[selectedIndex === -1 ? selectedValues.length : selectedIndex] = newValue
              }
            } else {
              selectedValues[selectedIndex === -1 ? selectedValues.length : selectedIndex] = newValue
            }
          } else {
            selectedValues = [newValue]
          }
        }
        this.$emit('input', selectedValues)
      },
    },
    mounted() {
      if (this.service) {
        api.getHostRemotePorts(this.hostsList.map(host => host.id)).then(portsByHost => {
          this.portsByHost = portsByHost
        })
      }
    },
  }
</script>

<style scoped>
  .empty { font-size: 1.3em!important; }
  .ui.card > .content { display: flex; flex-grow: 1!important; padding: 0!important; }
  .ui.buttons { margin: 0!important; width: auto!important; }
  .ui.buttons .ui.button { flex: 1; min-height: 4.7em; justify-content: flex-start!important; align-items: center!important; padding-left: 4em!important; white-space: nowrap; }
  .ui.buttons .ui.button:hover { background-color: #eee; box-shadow: none!important; }
  .ui.buttons .ui.button >>> .icon { display: flex; align-items: center; font-size: 1.3em; }
</style>
